<template>
  <div class="google-slides-info-box bg-light rounded p-3 mb-3">
    <div class="content-section">
      <div class="d-flex align-items-center mb-2">
        <h6 class="mb-0 me-2">
          {{ $i18nPresenter.t("There's a better way to use Google Slides") }}
        </h6>
        <span class="badge">
          {{ $i18nPresenter.t("New") }}
        </span>
      </div>
      <p class="mb-2">
        {{ $i18nPresenter.t("No more static embeds! With AhaSlides for Google Slides, you can create polls, quizzes, and more — directly inside your deck.") }}
      </p>
    </div>
    <div class="action-area d-flex justify-content-end">
      <aha-antd-button
        v-aha-emit-action
        name="get-google-slides-addon"
        variant="link"
        target="_blank"
        rel="noopener noreferrer"
        @click="openGoogleWorkspace"
      >
        <span class="d-inline-flex align-items-center">
          {{ $i18nPresenter.t("Get the Add-on") }}
          <aha-icon
            name="arrow-square-out"
            width="16"
            height="16"
            class="text-sm ml-2"
          ></aha-icon>
        </span>
      </aha-antd-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleSlidesInfoBox',
  methods: {
    openGoogleWorkspace() {
      window.open('https://workspace.google.com/marketplace/app/ahaslides_quiz_live_polls_word_clouds_mo/362095682738', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.google-slides-info-box {
  border: 1px solid #89BEFA;
  background-color: #F2F7FF !important;

  .content-section {
    margin-bottom: 8px;
  }

  h6 {
    font-weight: 700;
    font-size: 14px;
    color: #282E3E;
    line-height: 20px;
  }

  p {
    font-size: 0.875rem;
    line-height: 1.5;
    color: #282E3E;
  }

  .badge {
    font-size: 0.75rem;
    padding: 0.25em 0.5em;
    font-weight: 400;
    color: #33C173;
    background-color: #EBF9F1;
    border-radius: 4px;
    margin-left: 8px;
    align-self: flex-start;
  }
}
</style>
